import { buildMap } from "./update.js";

buildMap();
